export const environment = {
  production: true,
  database: 'verify-enterprise',
  functionRegion: 'europe-west1',
  sentryDsn:
    'https://535e1be5c5f9868f9d2ef6e2445d7e9a@o4510992598695936.ingest.de.sentry.io/4510997702508624',
  sentryEnvironment: 'production-eu',
  reCaptchaSiteKey: '6LdK4zUtAAAAAN4ZRBtCCqny1MMsyfgBDxZRFXa4',
  firebaseConfig: {
    apiKey: 'AIzaSyB8AnxCjytUqTj8rz83Hen2sKVfHeSH2pg',
    authDomain: 'fir-apps-prod-eu.firebaseapp.com',
    projectId: 'fir-apps-prod-eu',
    storageBucket: 'fir-apps-prod-eu.appspot.com',
    messagingSenderId: '748147608117',
    appId: '1:748147608117:web:019882f529d7a449cc7f7c',
    measurementId: 'G-XLR1Q24RSH',
  },
};
